export function VendorCreditApplicationsListCtrl ($scope, $state, $translate, gridAPI, workshopAPI, messages, confirm ) {

  $scope.tableSettings = {
    broadcast: 'filterQuotes',
    columns: [
      {
        field : 'vendor_invoice_number',
        header: {
          text: $translate.instant('INVOICE_SPACE.INVOICE_NUMBER')
        },
      },
      {
        field : 'created_on',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe  : 'date'
      },
      {
        field : 'amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe  : 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_APPLICATIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vendor_credit_application_items/count', $scope.vendor_invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.reverseCredits = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.REVERSE_CREDIT'))
    .then(function () {
      return workshopAPI.get('/vendor_invoice/reverse_credit_applications', $scope.vendor_invoice.id);
    }).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.CREDITS'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.onRowDoubleClick = function (application) {
    workshopAPI.get('/vendor_invoice', [application.row.vendor_invoice_id]).then(function (vendor_invoice) {
      $state.go('app.vendor-invoice', {
        vendor_id: vendor_invoice.vendor_id,
        id       : vendor_invoice.id
      });
    });
  };

  $scope.getApplications = ( params ) => {
    return workshopAPI.get('/vendor_credit_application_items/index', [
      $scope.vendor_invoice.id,
      params.offset,
      params.pageSize
    ]).then(function (applications) {
      $scope.applications = applications;
      if (applications.length) {
        $scope.$broadcast('open');
      }
      return applications;
    });
  };

  $scope.getApplications({offset: 0, pageSize: 5});
}